import { render, staticRenderFns } from "./CrmEntry.vue?vue&type=template&id=5e671cf7&scoped=true"
import script from "./CrmEntry.vue?vue&type=script&lang=js"
export * from "./CrmEntry.vue?vue&type=script&lang=js"
import style0 from "./CrmEntry.vue?vue&type=style&index=0&id=5e671cf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e671cf7",
  null
  
)

export default component.exports